export default __webpack_public_path__ + "static/image 49-11f6bd9d1bfdc51c63a26c80f65516c3.png";